export default "__VITE_ASSET__byaZQzCR__"